import router from "./router"
import urls, { DEFAULT_VIEW } from "./urls"

export default (name = DEFAULT_VIEW, params = {}) => {
  console.info(`Navigating to ${name} with params:`, params)
  router.push(urls[name].navigate(params))
}
